import { render, staticRenderFns } from "./OrderItemActions.vue?vue&type=template&id=c2acad24&scoped=true"
import script from "./OrderItemActions.vue?vue&type=script&lang=js"
export * from "./OrderItemActions.vue?vue&type=script&lang=js"
import style0 from "./OrderItemActions.vue?vue&type=style&index=0&id=c2acad24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2acad24",
  null
  
)

export default component.exports